import React, { useState } from 'react';
import { Pane, Textarea, Icon, PlusIcon, EditIcon, SideSheet, Heading, Paragraph, Button, TrashIcon, AddIcon, Spinner, Table, IconButton, EyeOpenIcon } from 'evergreen-ui';
import { IonFab, IonFabList, IonFabButton } from '@ionic/react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import moment from 'moment';

const CaseNotes = (props: any) => {

    const items = props.caseNotesList;
    const [showAddForm, setShowAddForm] = useState(false);
    const [noteText, setNoteText] = useState("");
    const handleCancel = () => { setShowAddForm(false) }

    const handleView = (caseNote: any) => {
        setNoteText(caseNote.noteText);
        setShowAddForm(true);
    }

    return (
        <div>
            <Pane padding={20}>
                {items !== undefined && items.length > 0 ?
                    <Row style={{ marginTop: '20px', marginLeft: '20px', marginRight: '20px', marginBottom: '20px', boxShadow: 'box-shadow: 0 0 1px rgb(67 90 111 / 30%), 0 2px 4px -2px rgb(67 90 111 / 47%)', border: '1px solid lightgray', borderRadius: '10px', paddingLeft: '0px', paddingRight: '0px' }}>
                        <Table style={{ width: '100%' }}>
                            <Table.Body>
                                {items.map((caseNote: any, index: number) => (
                                    <Table.Row key={index} style={{ height: 'auto' }}>
                                        <Table.TextCell>
                                            <div style={{ padding: '10px' }}>
                                                <Row>
                                                    <Col >
                                                        <p style={{ fontSize: "15px", fontWeight: 'bold' }}>{moment(caseNote.dateAdded).format("DD/MM/YYYY")} - Notes From: {caseNote.noteUser.name}</p>
                                                        <p>Message: {caseNote.noteText}</p>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Table.TextCell>
                                        <Table.Cell width={48} flex="none" style={{ background: 'white', borderLeft: '1px solid lightgray' }} onClick={() => handleView(caseNote)}>
                                            <IconButton icon={EyeOpenIcon} height={24} appearance="minimal" />
                                        </Table.Cell>
                                    </Table.Row>
                                ))}
                            </Table.Body>
                        </Table>
                    </Row>
                    :
                    <Row style={{ marginTop: '20px', marginLeft: '20px', marginRight: '20px', marginBottom: '20px', boxShadow: 'box-shadow: 0 0 1px rgb(67 90 111 / 30%), 0 2px 4px -2px rgb(67 90 111 / 47%)', padding: '20px', border: '1px solid lightgray', borderRadius: '10px', paddingLeft: '0px', paddingRight: '0px' }}>
                        <Heading style={{ paddingLeft: '20px' }}>No Case Notes</Heading>
                    </Row>}

                <SideSheet
                    isShown={showAddForm}
                    onCloseComplete={() => {
                        setShowAddForm(false);
                        setNoteText("");
                    }}
                    containerProps={{
                        display: 'flex',
                        flex: '1',
                        flexDirection: 'column'
                    }}
                >
                    <Pane zIndex={1} tabIndex={1} flexShrink={0} elevation={0} backgroundColor="white">
                        <Pane padding={16} paddingTop={32}>
                            <Pane display="flex" marginBottom={10}>
                                <Heading size={600}> Case Note</Heading>
                            </Pane>
                        </Pane>
                    </Pane>

                    <Pane flex="1" overflowY="scroll" background="tint1" padding={16}>
                        <Textarea id="textarea"
                            placeholder=""
                            height={150}
                            value={noteText}
                            disabled={true}
                        />

                        <Pane display="flex" float="right" paddingBottom={40} marginTop={20}>
                            <Button marginRight={16} appearance="primary" intent="danger" width={85} onClick={handleCancel}>Close</Button>
                        </Pane>
                    </Pane>
                    {/* {this.state.showFormLoading ?
              <Pane display="flex" alignItems="center" justifyContent="center" height="100%" background="rgba(0,0,0,0.05)" style={{ position: 'absolute', width: '100%', top: '0' }}>
                <Spinner></Spinner>
              </Pane> : null} */}
                </SideSheet>
            </Pane>
        </div>
    );
}

export default CaseNotes 